// marketerConsultantPageUtils.js — 마케터 1:1 관리 화면 도우미 (2026-10-06 페이지 386줄에서 글자 그대로 분리)
export const EMPTY_FORM = { marketer_user_id: '', consultant_user_id: '', start_date: '', end_date: '', monthly_salary: '', notes: '' };

export function normalizeMoney(value) {
  const raw = String(value || '').replace(/,/g, '');
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function normalizeCompanies(list) {
  if (!Array.isArray(list) || list.length === 0) return [{ code: 'PINE', name: 'PINE' }];
  return list
    .map((company) => ({
      code: String(company.code || company).trim().toUpperCase(),
      name: company.name || company.code || company,
    }))
    .filter((company) => company.code);
}

export function withIntegratedMenu(url, integratedMenuId) {
  if (!integratedMenuId) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}integrated_menu_id=${encodeURIComponent(integratedMenuId)}`;
}
